import { useEffect, useState } from "react";

export function useArray<T>(t: T): T[] {
  const [array, setArray] = useState([] as T[]);
  useEffect(() => setArray(t ? [t] : []), [t]);
  return array;
}
